<template>
  <div>
    <nav-bar></nav-bar>
    <!--------Pickup and delivery for restaurant details Strat------>
    <div v-if="showResturantDetail && (isPickupDelivery != '2' ? true : false)">
      <div
        class="vendor-details-main pb-4"
        id="reshead"
        :class="
          $auth.setting &&
          !(
            $auth.setting.product_type &&
            $auth.setting.product_type.id == 2 &&
            $auth.setting.store_selection == 0
          )
            ? 'menu-details cust-menu-list'
            : 'single-menu-details'
        "
      >
        <div
          class="container-fluid"
          v-if="
            $auth.setting &&
            !(
              $auth.setting.product_type &&
              $auth.setting.product_type.id == 2 &&
              $auth.setting.store_selection == 0
            )
          "
        >
          <div class="row">
            <div class="col-md-9">
              <div
                class="vendor-left-main text-capitalize d-flex cust-vendor-main res-items-main"
              >
                <div class="res-items-grid resturant-head">
                  <div class="res-items-left">
                    <div class="resimg-flex">
                      <div class="img-cls resimg-squre" :class="scheduleClass">
                        <skeleton-loader-vue
                          v-if="!resturantDetail.icon_image"
                          width="120px"
                          height="120px"
                          style="border-radius: 5px"
                        />
                        <img
                          v-else
                          :src="resturantDetail.icon_image"
                          alt="..."
                          @error="imageErrorHandle"
                        />
                      </div>
                      <div class="resimg-data">
                        <div class="d-flex align-items-center">
                          <h4 class="mt-0" v-if="!resturantDetail.name">
                            <skeleton-loader-vue
                              type="string"
                              width="45%"
                              height="20px"
                              style="bottom: 11px"
                            />
                          </h4>
                          <h4 class="mt-0" v-else>
                            {{ resturantDetail.name }}
                          </h4>

                          <div
                            class="d-flex justify-content-center mouse-hover ml-lg-5 ml-5"
                          >
                            <h3 @click="showRestaurantModal = true">
                              <!-- <b-icon icon="arrow-down" @click="showRestaurantModal = true"></b-icon> -->
                              <svg
                                width="30px"
                                height="30px"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g
                                  id="SVGRepo_tracerCarrier"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></g>
                                <g id="SVGRepo_iconCarrier">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z"
                                    fill="#000000"
                                  ></path>
                                </g>
                              </svg>
                            </h3>
                          </div>
                        </div>
                        <p v-if="resturantDetail.cuisine_name" class="cuisineList">{{ resturantDetail.cuisine_name.join(", ") }}</p>
                        <p class="mb-0" v-if="!resturantDetail.address">
                          <skeleton-loader-vue
                            type="string"
                            width="30%"
                            height="20px"
                          />
                        </p>
                        <p class="mb-0">{{ resturantDetail.address }}</p>
                        <p class="status-rest">
                          <span
                            :class="open_close.isOpen ? 'open' : 'closes'"
                            >{{ open_close.statusMessage }}</span
                          >
                          {{
                            open_close.scheduleMessage
                              ? open_close.scheduleMessage
                              : ""
                          }}
                        </p>
                        <div
                          class="info-view"
                          v-if="!resturantDetail.restaurant_id"
                        >
                          <skeleton-loader-vue
                            type="string"
                            class="skel_view"
                            width="25%"
                            height="31px"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="mobile--view mobile-viewinfo">
                      <div class="res-items-right">
                        <div class="marquee-btn-main viewinfo-new">
                          <div
                            class="rstinfo-cls rstinfo-cls-box deliveryfees-main"
                          >
                            <div class="restinfo-box">
                              <view-info
                                v-if="
                                  resturantDetail.restaurant_id &&
                                  is_scrren_hide
                                "
                                :restaurantID="resturantDetail.restaurant_id"
                              ></view-info>
                            </div>
                            <div class="restinfo-box">
                              <div
                                class="delivery-fees-nw mb-0 text-center"
                                v-if="
                                  resturantDetail &&
                                  resturantDetail.delivery_in != 0
                                "
                              >
                                <p class="mb-0">
                               {{ $t("Delivery in ") }}<br /><b
                                    >{{ resturantDetail.delivery_in }} Mins</b
                                  >
                                </p>
                              </div>
                            </div>
                            <div class="restinfo-box" v-if="is_rating">
                              <p class="mb-0 text-center">
                                {{
                                  `(${
                                    resturantDetail.rating_user_count || 0
                                  }) Reviews`
                                }}
                              </p>
                              <div class="review-cnt">
                                <div
                                  v-if="
                                    resturantDetail.rating != 0 && is_rating
                                  "
                                  class="star-rate"
                                  :class="
                                    parseFloat(resturantDetail.rating).toFixed(
                                      1
                                    ) > 2.0 ||
                                    parseFloat(resturantDetail.rating).toFixed(
                                      1
                                    ) == 0.0
                                      ? 'green-cls'
                                      : 'red-cls'
                                  "
                                >
                                  <i class="fas fa-star mr-2"></i>
                                  <span v-if="resturantDetail.rating == 0">{{
                                    parseFloat(resturantDetail.rating).toFixed(
                                      1
                                    )
                                  }}</span>
                                  <span v-else>{{
                                    parseFloat(resturantDetail.rating).toFixed(
                                      1
                                    )
                                  }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="restinfo-box">
                              <div
                                class="delivery-minutes"
                                v-if="
                                  is_twoPersonPrice &&
                                  resturantDetail &&
                                  resturantDetail.two_person_price != 0
                                "
                              >
                                <!-- <h5 class="mb-0" v-if="resturantDetail.two_person_price">
                                  <span v-if="$auth.setting.currency" v-html="$auth.setting.currency" class="currency"></span>{{parseFloat(resturantDetail.two_person_price).toFixed(1)}}
                                </h5> -->
                                <p class="mb-0">
                                  {{ $t("Cost For two") }} <br /><b
                                    ><span
                                      v-if="$auth.setting.currency"
                                      v-html="$auth.setting.currency"
                                      class="currency"
                                    ></span
                                    >{{
                                      parseFloat(
                                        resturantDetail.two_person_price
                                      ).toFixed(1)
                                    }}</b
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="res-items-right desktop--view"
                    v-if="resturantDetail"
                  >
                    <div class="search-button">
                      <div
                        class="searchbar-item mt-lg-2 mt-2 mb-lg-2 mb-2 ml-0"
                      >
                        <input
                          type="text"
                          name="search"
                          placeholder="Search"
                          v-model="search_item"
                          class="srch-itm"
                        />
                      </div>
                    </div>

                    <div class="marquee-btn-main viewinfo-new">
                      <div
                        class="rstinfo-cls rstinfo-cls-box deliveryfees-main"
                      >
                        <div class="restinfo-box">
                          <div
                            class="delivery-fees-nw"
                            v-if="
                              resturantDetail &&
                              resturantDetail.delivery_in != 0
                            "
                          >
                            <!-- <p class="mb-0">{{$t('Delivery in ')}}{{resturantDetail.delivery_in}}</p> -->
                            <p class="mb-0 text-center">
                              {{ $t("Delivery in ") }}<br /><b
                                >{{ resturantDetail.delivery_in }} Mins</b
                              >
                            </p>
                          </div>
                        </div>
                        <div class="restinfo-box" v-if="is_rating">
                          <p class="mb-0 text-center">
                            {{
                              `(${
                                resturantDetail.rating_user_count || 0
                              }) Reviews`
                            }}
                          </p>
                          <div class="review-cnt">
                            <div
                              v-if="is_rating"
                              class="star-rate"
                              :class="
                                parseFloat(resturantDetail.rating).toFixed(1) >
                                  2.0 ||
                                parseFloat(resturantDetail.rating).toFixed(1) ==
                                  0.0
                                  ? 'green-cls'
                                  : 'red-cls'
                              "
                            >
                              <i class="fas fa-star mr-2"></i>
                              <span v-if="resturantDetail.rating == 0">{{
                                parseFloat(resturantDetail.rating).toFixed(1)
                              }}</span>
                              <span v-else>{{
                                parseFloat(resturantDetail.rating).toFixed(1)
                              }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="restinfo-box">
                          <div
                            class="delivery-minutes"
                            v-if="
                              is_twoPersonPrice &&
                              resturantDetail &&
                              resturantDetail.two_person_price != 0
                            "
                          >
                            <!-- <h5 class="mb-0" v-if="resturantDetail.two_person_price">
                              <span v-if="$auth.setting.currency" v-html="$auth.setting.currency" class="currency"></span>{{parseFloat(resturantDetail.two_person_price).toFixed(1)}}
                            </h5> -->
                            <p class="mb-0 text-center">
                              {{ $t("Cost For two") }} <br /><b
                                ><span
                                  v-if="$auth.setting.currency"
                                  v-html="$auth.setting.currency"
                                  class="currency"
                                ></span
                                >{{
                                  parseFloat(
                                    resturantDetail.two_person_price
                                  ).toFixed(1)
                                }}</b
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center viewinfo-desktop">
                <view-info
                  class="desktop--view"
                  v-if="resturantDetail.restaurant_id && !is_scrren_hide"
                  :restaurantID="resturantDetail.restaurant_id"
                ></view-info>
                <!-- <marquee v-if="resturantDetail.weather_text != 'null' && resturantDetail.weather_text != ''" class="marque-text custom-marque" attribute_name = "attribute_value" attributes>{{resturantDetail.weather_text}}</marquee> -->
              </div>
            </div>
          </div>
        </div>
        <cart></cart>
      </div>
      <div class="resturant-menu-main">
        <div class="container-fluid m-0">
          <div class="row">
            <div class="col pe-lg-0 pr-0 pl-0 resturant-menu-wrapper">
              <div class="menuitems-main">
                <item-list
                  ref="itemlistrefs"
                  :restaurant_on_off="resturantDetail.restaurant_on_off"
                  v-if="resturantDetail && resturantDetail.restaurant_id"
                  :restautantDetails="resturantDetail"
                  v-on:getCategoryList="categoryList"
                  :allRestaurantData="allRestaurantData"
                  :search_item="search_item"
                  :best_seller_ids="best_seller_ids"
                  :recommodation_ids="recommodation_ids"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--------Pickup and delivery for restaurant details End------>
    <section
      class="fixed-box faqs-start-main"
      v-else-if="
        showResturantDetail && (isPickupDelivery == '2' ? true : false)
      "
    >
      <div
        class="orders-tab-main review-container review-main text-capitalize position-relative cust-review-main"
      >
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="resturant-details-box position-relative">
              <div class="reservation-table-warapper">
                <div class="resimg-squre mr-lg-3 mr-2">
                  <img
                    src="https://storage.googleapis.com/deonde-prod/media/Restaurant_Icon_image/original/deonde_17182638492904.jpeg"
                    alt="..."
                    class="itmimg"
                  />
                </div>

                <div class="res-detail-left status-con">
                  <div class="map-call-icon-wrapper">
                    <div>
                      <h6 class="main-title">{{ resturantDetail.name }}</h6>
                    </div>
                    <div class="res-detail-left status-con">
                      <div class="res-detail-right map-spport">
                        <span
                          ><i class="fas fa-phone-alt" aria-hidden="false"></i
                        ></span>
                        <span
                          ><a
                            v-if="latitude"
                            :href="
                              'https://www.google.com/maps?saddr=' +
                              latitude +
                              ',' +
                              longitude +
                              '&daddr=' +
                              resturantDetail.latitude +
                              ',' +
                              resturantDetail.longitude
                            "
                            target="_blank"
                            ><i
                              class="fas fa-location-arrow"
                              aria-hidden="true"
                            ></i></a
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div class="desktop-show">
                    <p v-if="resturantDetail.cuisine_name">
                      {{ resturantDetail.cuisine_name.join(", ") }}
                    </p>
                    <p class="status-rest">
                      <span :class="open_close.isOpen ? 'open' : 'closes'">{{
                        open_close.statusMessage
                      }}</span>
                      {{
                        open_close.scheduleMessage
                          ? open_close.scheduleMessage
                          : ""
                      }}
                    </p>
                  </div>
                  <div class="cuisine-container mobile-show">
                    <input
                      type="checkbox"
                      id="toggle"
                      class="toggle-checkbox"
                    />

                    <p
                      class="cuisine-list"
                      v-if="resturantDetail && resturantDetail.cuisine_name"
                    >
                      {{ resturantDetail.cuisine_name.slice(0, 2).join(", ")
                      }}<span class="more-text">, ...</span>
                      <span class="full-text">
                        {{ resturantDetail.cuisine_name.slice(2).join(", ") }}
                      </span>
                    </p>
                    <label for="toggle" class="toggle-label"></label>
                  </div>

                  <div class="resturant-details-box px-0 mt-lg-1 mt-2">
                    <view-info
                      :restaurantID="resturantDetail.restaurant_id"
                    ></view-info>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-body mt-lg-3 mt-2">
              <!-- <ul class="nav nav-tabs border-0 mb-3">
                <li class="nav-item">
                  <a href="#overview" class="nav-link navbar-default active" data-toggle="tab">Overview</a>
                  </li>
                  <li class="nav-item">
                    <a href="#menu" class="nav-link navbar-default" data-toggle="tab">Menu</a>
                  </li>
                </ul> -->

              <div class="tab-content">
                <h5 class="main-title mb-0">Book Table</h5>
                <div id="overview" class="tab-pane active tab-box ta">
                  <div class="days-list mt-lg-3 mt-2" v-if="allDays.length > 0">
                    <ul class="day-start">
                      <li class="select-mnth">
                        <p>
                          {{ selectMonth
                          }}<i class="fas fa-calendar" aria-hidden="true"></i>
                        </p>
                      </li>
                      <li
                        class="day-nme"
                        v-for="(day, i) in allDays.slice(0, 5)"
                        :key="i"
                        @click="
                          selectDate(
                            day.date,
                            day.fulldayname,
                            day.isToday,
                            day.monthname,
                            day.dayname
                          )
                        "
                        :class="day.dayname == selectDay ? 'active' : ''"
                      >
                        <span>{{ day.monthdaynumber }}</span>
                        <h5>{{ day.dayname }}</h5>
                      </li>
                    </ul>
                  </div>
                  <div class="days-list mt-lg-4 mt-2">
                    <h6 class="sub-title">Time</h6>
                    <p>Choose an available time Slots</p>
                    <ul class="time-start" v-if="times.length > 0">
                      <li
                        class="day-tme"
                        v-for="(time, i) in times"
                        :key="i"
                        @click="selectTimeSlot(time)"
                        :class="
                          time == selectTime
                            ? 'active'
                            : i == 0 && selectTime == ''
                            ? 'active'
                            : ''
                        "
                      >
                        <p>{{ time }}</p>
                      </li>
                    </ul>
                    <div class="nottimeslot" v-else>
                      <img src="@/assets/images/no-time-slot.svg" />
                      <p>
                        No time slots available<span class=""
                          >Select Other Date & Time</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="guest-section mt-lg-3 mt-2">
                    <h4 class="sub-title">Select Guests</h4>
                    <p>Choose the number of guests going</p>
                    <div class="guest-number">
                      <p>Number of Guests</p>
                      <div class="number d-flex align-items-center">
                        <span
                          class="minus d-flex justify-content-center align-items-center"
                          @click="minusGuest()"
                          >-</span
                        >
                        <input
                          type="number"
                          v-model="guestCount"
                          @input="guestCountNumber"
                        />
                        <span
                          class="plus d-flex justify-content-center align-items-center"
                          @click="plusGuest()"
                          >+</span
                        >
                      </div>
                    </div>
                    <div class="instruct-sect mt-4">
                      <div class="review-boxs">
                        <h6 class="mb-2">special instructions</h6>
                        <textarea
                          rows="2"
                          style="resize: none"
                          class="form-control mb-0 h50"
                          type="search"
                          placeholder="If you have any special instructions for this order. Please type here"
                          aria-label="instructions"
                          v-model="instructions"
                        />
                      </div>
                    </div>
                    <div class="cust-info mt-4">
                      <h6 class="mb-2">Customer Info</h6>
                      <p>Customer information for table booking</p>
                      <input
                        type="text"
                        v-model="form.name"
                        class="form-control mb-3"
                        placeholder="Enter Name"
                        :class="{ 'is-invalid': $v.form.name.$error }"
                      />
                      <div v-if="$v.form.name.$error" class="invalid-feedback">
                        <span v-if="!$v.form.name.required">Enter Name.</span>
                      </div>
                      <div class="cust-mbil mt-2 custom-number">
                        <span class="contry-code">+91</span>
                        <input
                          type="text"
                          @input="acceptNumber"
                          v-model="form.mobile"
                          class="form-control mb-3"
                          placeholder="Enter your Mobile Number"
                          :class="{ 'is-invalid': $v.form.mobile.$error }"
                          maxlength="10"
                        />
                      </div>
                      <div
                        v-if="$v.form.mobile.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.mobile.required"
                          >Enter Mobile Number.</span
                        >
                      </div>
                      <input
                        type="email"
                        v-model="form.email"
                        class="form-control mb-3"
                        placeholder="Enter Email Id (Optional)"
                      />
                    </div>
                  </div>
                  <button
                    class="btn resvation-btn mt-4 btn-default btn-secondary"
                    :class="selectTime == '' ? 'noButtom' : ''"
                    @click="bookNow()"
                    :disabled="selectTime == '' ? true : false"
                  >
                    Book Now
                  </button>
                </div>
                <div id="menu" class="tab-pane tab-box">
                  <b-spinner
                    v-if="is_spinning"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                  <iframe
                    v-else
                    class="embed-responsive-item"
                    :src="menuLink"
                    style="
                      width: 100%;
                      border: none;
                      min-height: 100px;
                      max-height: 750px;
                      height: 100vh;
                    "
                    allowfullscreen
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-else class="noDetails">
      <div class="no-cont-cls">
        <p>{{ $t("Uh oh") }}.</p>
        <p>{{ $t("This page doesn`t seem to exist") }}</p>
        <button class="back-btn btn go-cls" @click="goToHome()">
          {{ $t("Home") }}
        </button>
      </div>
    </div>
    <h1></h1>
    <div class="cat-start" :class="displayCategory ? 'cat-open-mnu' : ''">
      <div class="catg-mnu-list menu-item-main">
        <div
          id="category"
          class="catelist"
          v-if="categorys.length > 0 && displayCategory"
        >
          <nav>
            <ul>
              <li v-for="(cate, i) in categorys" :key="i">
                <a
                  :class="
                    cate.restaurant_menu_id == selectMenuCategoryId
                      ? 'active'
                      : ''
                  "
                  href="javascript:void(0)"
                  @click="selectMenuCate(cate.restaurant_menu_id)"
                  >{{ cate.menu_name }}</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <span
        @click="openCategoty"
        v-click-outside="onClickOutside"
        class="menuopen-btn"
        v-if="
          showResturantDetail &&
          (isPickupDelivery == '2' ? false : true) &&
          categorys.length > 0
        "
        >Menu</span
      >
    </div>

    <div class="mobile-cart full-btn mobile-cart-main" v-if="cart.length > '0'">
      <span class="licence-span text-center" v-if="fssaiLicence"
        >FSSAI Licence Number : {{ fssaiLicence }}</span
      >
      <a
        v-if="!is_btn_spinner"
        href="javascript:void(0)"
        class="mb-view-cart cart-button d-flex justify-content-between"
        @click="minimunOrderValue()"
      >
        <div>
          {{ cart.reduce((a, c) => a + c.quantity, 0) }}
          {{
            cart.reduce((a, c) => a + c.quantity, 0) > 1
              ? $t("Items")
              : $t("Item")
          }}
          |
          <span
            v-html="$auth.setting && $auth.setting.currency"
            class="currency"
          ></span
          >{{ getTotalAmount().toFixed(2) }}
        </div>
        <span>View Cart</span>
      </a>
      <b-button
        v-else
        variant="primary"
        class="mb-view-cart cart-button d-flex justify-content-between"
        disabled
      >
        <b-spinner small type="grow"></b-spinner>{{ $t("Loading") }}...
      </b-button>
    </div>
    <!--Alert Modal start-->
    <AlertModal
      v-if="isAlert"
      :DisplayAlertData="AlertData"
      v-on:modalClose="onModalCloseFun"
    ></AlertModal>
    <!--Alert Modal End-->

    <Vendor
      v-if="showRestaurantModal"
      @storeModal="showRestaurantModal = false"
      :activeID="resturantDetail.restaurant_id"
    ></Vendor>
    <Footer v-if="resturantDetail.restaurant_id"></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import NavBar from "@/components/NavBar.vue";
import Cart from "@/components/Cart.vue";
import Rating from "@/components/Rating.vue";
import ItemList from "@/components/ItemList.vue";
import ViewInfo from "@/components/ViewInfo.vue";
import Vendor from "@/components/Vendor.vue";
import Footer from "../components/Footer.vue";

import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import VueSkeletonLoader from "skeleton-loader-vue";
import { required, numeric } from "vuelidate/lib/validators";
import moment from "moment";
import AlertModal from "../components/AlertModal.vue";
import { imageErrorHandle } from "../helper/helper.js";

Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});
export default {
  name: "itemDetail",
  components: {
    NavBar,
    Cart,
    Rating,
    ItemList,
    ViewInfo,
    Footer,
    "skeleton-loader-vue": VueSkeletonLoader,
    AlertModal,
    Vendor,
  },
  data() {
    return {
      imageErrorHandle: imageErrorHandle,
      best_seller_ids: [],
      recommodation_ids: [],
      search_item: "",
      showRestaurantModal: false,
      resturantDetail: {},
      allRestaurantData: {},
      showResturantDetail: true,
      is_rating: false,
      is_twoPersonPrice: false,
      is_minimuOrder: false,
      scheduleClass: "",
      system_start_time: "",
      system_end_time: "",
      is_same_day_delivery: 0,
      timeFormat: "HH:mm:ss",
      dateFormat: "YYYY-MM-DD",
      store_dine_time: [],
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      currentDate: new Date(),
      currentTime: new Date().toLocaleTimeString(),
      currentMinute: new Date().getMinutes(),
      allDays: [],
      selectDay: "",
      selectMonth: "",
      opencloseTimes: [],
      statTimeSlot: [],
      currentDay: "",
      defaultDayname: "",
      times: [],
      instructions: "",
      selectTime: "",
      guestCount: 1,
      menuLink: "",
      is_spinning: true,
      form: {
        name: "",
        email: "",
        mobile: "",
      },
      licenceNumber: "",
      latitude: parseFloat(localStorage.getItem("latitude")),
      longitude: parseFloat(localStorage.getItem("longitude")),
      fssaiLicence: "",
      categorys: [],
      displayCategory: false,
      AlertData: {},
      isAlert: false,
      selectMenuCategoryId: 0,
      is_scrren_hide: window.screen.width < 1280 ? true : true,
      is_btn_spinner: false,
      dineinTimming: [],
      open_close: {
        statusMessage: "",
        scheduleMessage: "",
        isOpen: false,
      },
      currentTime: moment(),
    };
  },

  validations: {
    form: {
      name: {
        required,
      },
      mobile: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("order", ["isPickupDelivery"]),
    ...mapGetters("product", ["cart"]),
  },

  mounted() {
    setTimeout(() => {
      if (this.isPickupDelivery == 2) {
        this.$store.commit("order/pickupdelivery", "2");
        this.getDineRestaurantDetail();
      } else if (this.isPickupDelivery == 1) {
        this.getRestaurantDetail();
      }
      // else if(this.$route.path.includes('delivery')){
      //   this.$store.commit("order/pickupdelivery",'1');
      //   this.getRestaurantDetail();
      // }else if(this.$route.path.includes('takeaway')){
      //   this.$store.commit("order/pickupdelivery",'0');
      //   this.getRestaurantDetail();
      // }
    }, 2000);
    this.is_rating = true;
    // setTimeout(() => this.resturantDetail.rating > 0 ? this.is_rating = true:'', 2000);
    setTimeout(() => (this.is_twoPersonPrice = true), 2000);
    setTimeout(() => (this.is_minimuOrder = true), 2000);
    this.currentDay = this.days[this.currentDate.getDay()];
  },

  methods: {
    ...mapActions("restaurant", [
      "getRestaurantMenus",
      "getDineRestaurantBySlug",
      "getRestaurantDetails",
      "getRestaurantOffers",
    ]),
    ...mapActions("order", ["OrderPreBooking"]),
    ...mapMutations("order", ["pickupdelivery"]),
    ...mapActions("product", ["addOffers"]),

    restaurantDynamicText() {
      const todayTimming = this.dineinTimming.filter(
        (timming) => timming.day === this.currentDay && timming.status != 0
      );

      // if (
      //   todayTimming.length === 0 ||
      //   this.resturantDetail.restaurant_on_off =='0'
      // ) {
      if (todayTimming.length === 0) {
        this.open_close.statusMessage = "Closed Right Now";
        this.open_close.scheduleMessage = "";
        return;
      }

      let isOpen = false;
      let minutesUntilClose = null;
      let minutesUntilOpen = null;

      todayTimming.forEach((timming) => {
        let close_Time = timming.close_time;

        if (close_Time === "00:00:00") {
          close_Time = "23:59:00";
        }

        const openTime = moment(timming.open_time, "HH:mm:ss");
        const closeTime = moment(close_Time, "HH:mm:ss");

        if (
          closeTime.format("HH:mm:ss") === "23:59:00" &&
          this.currentTime.isAfter(closeTime)
        ) {
          closeTime.add(1, "day");
        }

        if (this.currentTime.isBetween(openTime, closeTime, null, "[)")) {
          isOpen = true;
          minutesUntilClose = closeTime.diff(this.currentTime, "minutes");
        }
      });

      if (isOpen) {
        this.open_close.isOpen = true;
        if (minutesUntilClose <= 60) {
          this.open_close.statusMessage = `Open`;
          this.open_close.scheduleMessage = `- Closes in ${minutesUntilClose} minutes`;
        } else {
          this.open_close.statusMessage = "Open";
          this.open_close.scheduleMessage = "";
        }
      } else {
        let nextOpenTime = null;

        todayTimming.forEach((timming) => {
          const openTime = moment(timming.open_time, "HH:mm:ss");
          if (this.currentTime.isBefore(openTime)) {
            if (!nextOpenTime || openTime.isBefore(nextOpenTime)) {
              nextOpenTime = openTime;
            }
          }
        });

        if (nextOpenTime) {
          const minutesUntilNextOpen = nextOpenTime.diff(
            this.currentTime,
            "minutes"
          );
          if (minutesUntilNextOpen <= 60) {
            this.open_close.isOpen = false;
            this.open_close.statusMessage = `Closed Right Now`;
            this.open_close.scheduleMessage = `- Open in ${minutesUntilNextOpen} minutes`;
          } else {
            this.open_close.statusMessage = "Closed Right Now";
            this.open_close.scheduleMessage = "";
          }
        } else {
          this.open_close.isOpen = false;
          this.open_close.scheduleMessage = "";
          this.open_close.statusMessage = "Closed Right Now";
        }
      }

      return;
    },
    getRestaurantDetail() {
      this.getRestaurantMenus({
        delivery_type_time_slots: this.isPickupDelivery,
        latitude: localStorage.getItem("latitude"),
        longitude: localStorage.getItem("longitude"),
        menu_category_id: "0",
        restaurant_id: atob(this.$route.params.restaurantId),
        search_text: "",
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
      }).then((data) => {
        if (data.code == 200) {
          this.$auth.setRestauranID(data.restaurant_details.restaurant_id);
          if (data?.restaurant_details.is_confirm == 0) {
            return this.$router.push({ name: "Home" });
          }
          this.allRestaurantData = data?.Result ?? {};
          this.resturantDetail = data?.restaurant_details ?? {};
          this.dineinTimming = this.resturantDetail.delivery_timing || [];
          this.best_seller_ids = data?.best_seller_items ?? [];
          this.recommodation_ids = data?.recommodation_items ?? [];
          this.$auth.setRestauranID(data.restaurant_details.restaurant_id);
          this.showResturantDetail = true;
          this.fssaiLicence = data.restaurant_details.fssai_licence ?? "";
          this.restaurantDynamicText();

          this.allOffers();
          // this.addOffers( data?.offers ?? []);

          //this.licenceNumber = this.resturantDetail.business_licence_number;
          //Add Class Schedule or Closed
          // if(data.Result.restaurant_on_off == '0' && this.$auth.setting && this.$auth.setting.is_enable_schedule_order_after_business_hours == 0){
          //   this.scheduleClass = 'closed';
          // }else if(data.Result.restaurant_on_off == '0' && this.$auth.setting && this.$auth.setting.is_enable_schedule_order_after_business_hours == 1){
          //   this.scheduleClass = 'Schedule';
          // }
          // const descEl = document.querySelector('head meta[name="description"]');
          // const titleEl = document.querySelector('head title');
          // const keywordEl = document.querySelector('head meta[name="keywords"]');
          // descEl.setAttribute('content', this.resturantDetail.seo_meta);
          // titleEl.textContent = (this.resturantDetail.seo_title == '' || this.resturantDetail.seo_title == null ?this.resturantDetail.name:this.resturantDetail.seo_title);
          // keywordEl.setAttribute('content', this.resturantDetail.seo_keyword);

          if (data.Result.restaurant_on_off == "0") {
            this.scheduleClass = "closed";
          }
        } else {
          this.showResturantDetail = false;
        }
      });
    },
    allOffers() {
      this.getRestaurantOffers({
        restaurant_id: atob(this.$route.params.restaurantId),
        vendor_id: this.$auth.getVendorId(),
        user_id: this.$auth?.user?.user_id ? this.$auth.user.user_id : "",
      }).then((data) => {
        if (data.code == 200) {
          this.addOffers(data?.Result ?? []);
        } else {
          this.addOffers([]);
        }
      });
    },
    getDineRestaurantDetail() {
      this.getDineRestaurantBySlug({
        vendor_id: this.$auth.getVendorId(),
        slug: this.$route.params.restaurant_name,
        is_langauge: this.$store.state.lang.locale,
      }).then((data) => {
        if (data.code == 200) {
          this.resturantDetail = data.Result;
          this.dineinTimming = data.Result.dinein_timming || [];
          this.restaurantDynamicText();
          this.$auth.setRestauranID(data.Result.restaurant_id);
          this.showResturantDetail = true;
          if (this.$auth.setting) {
            this.system_start_time =
              this.$auth.setting && this.$auth.setting.system_start_time != ""
                ? this.$auth.setting.system_start_time.split(" ").pop()
                : "00:00:00";
            this.system_end_time =
              this.$auth.setting.system_end_time != ""
                ? this.$auth.setting.system_end_time.split(" ").pop()
                : "23:59:00";
            this.is_same_day_delivery = this.$auth.setting.is_same_day_delivery;
          }
          if (this.$auth.user) {
            this.form.email = this.$auth.user.user_email;
            this.form.mobile = this.$auth.user.mobile_number;
            this.form.name = this.$auth.user.user_name;
          }
          //Add Class Schedule or Closed
          if (
            data.Result.restaurant_on_off == "0" &&
            this.$auth.setting &&
            this.$auth.setting.is_enable_schedule_order_after_business_hours ==
              0
          ) {
            this.scheduleClass = "closed";
          } else if (
            data.Result.restaurant_on_off == "0" &&
            this.$auth.setting &&
            this.$auth.setting.is_enable_schedule_order_after_business_hours ==
              1
          ) {
            this.scheduleClass = "Schedule";
          }
          if (this.resturantDetail.dinein_timming) {
            //For Takeaway
            this.resturantDetail.dinein_timming.forEach((elm) => {
              if (elm.status == 1) {
                this.store_dine_time.push(elm);
              }
            });
          }
          this.menuLink = this.resturantDetail.dine_menu_link;
          this.is_spinning = false;
          this.createDays();
        } else {
          this.showResturantDetail = false;
        }
      });
    },

    createDays() {
      this.allDays = [];
      let daysToCalculate = 7;
      let dayId = 1;
      /*******First Day Select******* */
      let dayname = this.shortDays[this.currentDate.getDay()];
      let monthname = this.currentDate.toLocaleString("default", {
        month: "short",
      });
      let fulldayname = this.days[this.currentDate.getDay()];
      let monthdaynumber = this.currentDate.getDate();
      let date =
        this.currentDate.getFullYear() +
        "-" +
        (this.currentDate.getMonth() + 1) +
        "-" +
        this.currentDate.getDate();
      let dayData = {
        id: dayId,
        dayname: dayname,
        monthname: monthname,
        monthdaynumber: monthdaynumber,
        fulldayname: fulldayname,
        date: moment(date).format(this.dateFormat),
        isToday: true,
        isTomorrow: false,
      };
      this.allDays.push(dayData);
      this.selectedDate = moment(date).format(this.dateFormat);
      this.selectMonth = monthname;
      this.selectDay = dayname;
      dayId++;
      daysToCalculate = daysToCalculate - 1;
      this.defaultDayname = fulldayname;
      /*******First Day Select******* */
      /*******other Day Select******* */
      for (let day = 1; day <= daysToCalculate; day++) {
        let currentCalDate = new Date();
        let fulldate = new Date(
          currentCalDate.setDate(currentCalDate.getDate() + day)
        );

        let dayFullName = this.days[fulldate.getDay()];
        let dayname = this.shortDays[fulldate.getDay()];
        let monthname = fulldate.toLocaleString("default", { month: "short" });
        let monthdaynumber = fulldate.getDate();
        let date =
          currentCalDate.getFullYear() +
          "-" +
          (currentCalDate.getMonth() + 1) +
          "-" +
          currentCalDate.getDate();
        let dayData = {
          id: dayId,
          dayname: dayname,
          monthname: monthname,
          monthdaynumber: monthdaynumber,
          fulldayname: dayFullName,
          date: moment(date).format(this.dateFormat),
          isToday: false,
          isTomorrow: day == 1 ? true : false,
        };
        this.allDays.push(dayData);
        dayId++;
      }
      /*******other Day Select******* */
      this.createTimes();
    },

    createTimes() {
      let openTime = "";
      let closeTime = "";
      if (this.store_dine_time.length > 0) {
        this.store_dine_time.forEach((elm) => {
          if (this.system_start_time > elm.open_time) {
            openTime = this.system_start_time;
          } else {
            openTime = elm.open_time;
          }

          if (this.system_end_time > elm.close_time) {
            closeTime = elm.close_time;
          } else {
            closeTime = this.system_end_time;
          }
          this.opencloseTimes.push({
            openTime: openTime,
            closeTime: closeTime,
            day: elm.day,
          });
        });
      } else {
        openTime = this.system_start_time;
        closeTime = this.system_end_time;
        this.opencloseTimes.push({
          openTime: openTime,
          closeTime: closeTime,
          day: this.currentDay,
        });
      }
      let startTime = this.system_start_time;
      let endTime =
        this.system_end_time == "00:00:00" ? "23:59:00" : this.system_end_time;
      let convOpenTime = moment(startTime, this.timeFormat);

      this.statTimeSlot = this.getTimeStops(startTime, endTime);
      if (this.statTimeSlot.length > 1) {
        let sTime = moment(
          this.statTimeSlot[this.statTimeSlot.length - 1],
          this.timeFormat
        );
        let eTime = moment(endTime, this.timeFormat);
        let dur = moment.duration(eTime.diff(sTime));
        let min = parseInt(dur.asMinutes()); //-hrs*60;
        if (min > 0) {
          this.statTimeSlot.push(
            sTime.add(min, "minutes").format(this.timeFormat)
          );
        }
      }

      if (this.is_same_day_delivery) {
        this.selectDate(
          this.selectedDate,
          this.currentDay,
          true,
          this.selectMonth,
          this.selectDay
        );
      } else {
        this.selectDate(
          this.selectedDate,
          this.defaultDayname,
          false,
          this.selectMonth,
          this.selectDay
        );
      }
    },

    selectDate(date, fulldayname, isToday, selectMonth, shortDay) {
      this.times = [];
      this.selectDay = shortDay;
      this.selectMonth = selectMonth;
      this.selectedDate = date;
      let time = this.opencloseTimes.filter((el) => el.day == fulldayname);
      if (time) {
        if (time.length > 0) {
          time.forEach((elm, ind) => {
            let nestim = moment(this.currentTime, "HH:mm");
            let newcutime = new moment(nestim).format("hh:mm a");
            let firstEl = this.statTimeSlot.find((el) => el >= newcutime);
            let result = [];
            let openTime = elm.openTime;
            let closeTime =
              elm.closeTime == "00:00:00" ? "23:59:00" : elm.closeTime;
            let convOpenTime = moment(openTime, this.timeFormat);
            result = this.getTimeStops(openTime, closeTime);
            if (firstEl) {
              let temp = result.filter((el) => firstEl > el);
              temp.forEach((el) => {
                let newel = moment(el, ["hh:mm a"]).format("HH:mm");
                let time = moment(newel, "HH:mm");
                let time2 = "";
                if (fulldayname === moment().format("dddd")) {
                  time2 = moment().add(1, "hours");
                  if (time.isAfter(time2)) {
                    this.times.push(el);
                  }
                  this.selectTime = this.times[0];
                } else {
                  this.times.push(el);
                  this.selectTime = this.times[0];
                }
              });
            } else {
              result.forEach((el) => {
                this.times.push(el);
              });
            }
          });
        } else {
          this.selectTime = "";
        }
      } else {
        this.selectTime = "";
      }
    },

    getTimeStops(start, end) {
      let startTime = moment(start, "HH:mm");
      var endTime = moment(end, "HH:mm");
      if (endTime.isBefore(startTime)) {
        endTime.add(1, "day");
      }
      var timeStops = [];
      // let netoday = moment().format("HH:mm:ss");
      // startTime = moment(netoday, "HH:mm");
      while (startTime <= endTime) {
        timeStops.push(new moment(startTime).format("hh:mm a"));
        startTime.add(15, "minutes");
      }
      return timeStops;
    },

    selectTimeSlot(value) {
      this.selectTime = value;
    },

    plusGuest() {
      if (this.guestCount < "10") {
        this.guestCount++;
      } else {
        alert("Sorry, you are not allow to add more than 10 guests");
      }
    },

    minusGuest() {
      if (this.guestCount > "1") {
        this.guestCount--;
      }
    },

    bookNow() {
      let future_delivery_date = "";
      if (this.selectTime == "" && this.times) {
        future_delivery_date =
          this.selectedDate +
          " " +
          moment(this.times[0], "hh:mm A").format("HH:mm");
      } else {
        future_delivery_date =
          this.selectedDate +
          " " +
          moment(this.selectTime, "hh:mm A").format("HH:mm");
      }
      if (this.$auth.user) {
        this.$v.$touch();
        if (this.$v.form.$invalid) {
          return false;
        } else {
          if (Number(this.guestCount) != 0 && Number(this.guestCount) <= 10) {
            this.OrderPreBooking({
              user_email: this.form.email,
              notes: this.instructions,
              guests_count: this.guestCount,
              user_name: this.form.name,
              restaurant_id: this.resturantDetail.restaurant_id,
              device_type: "WEB",
              future_delivery_date: future_delivery_date,
              is_langauge: this.$store.state.lang.locale,
              user_id: this.$auth.user.user_id,
              delivery_pickup_types: "Dine In",
              app_version_code: "1.1",
              vendor_id: this.$auth.getVendorId(),
              user_mobile_number: this.form.mobile,
            }).then((data) => {
              if (data.code == 200) {
                this.$toasted.success(data.msg + " " + data.Result, {
                  duration: 2000,
                });
                this.$router.push({ name: "bookinghistory" });
              }
            });
          } else {
            alert("Sorry, you are not allow to add more than 10 guests");
          }
        }
      } else {
        this.$router.push({ name: "sign-in" });
      }
    },

    acceptNumber() {
      if (!/[0-9]/.test(this.form.mobile)) {
        return (this.form.mobile = "");
      }
      return true;
    },

    guestCountNumber() {
      if (
        (this.guestCount != "" && this.guestCount > 10) ||
        this.guestCount <= 0
      ) {
        alert("Value should be between 0 and 10");
        this.guestCount = 1;
      } else {
        return true;
      }
    },
    goToHome() {
      this.$router.go(-1);
    },
    getTotalAmount() {
      let total = 0;
      this.cart.forEach((item) => {
        total += item.price * item.quantity;
      });
      return total;
    },
    openCategoty() {
      this.displayCategory = true;
    },
    categoryList(value, selectid) {
      this.categorys = value;
      this.selectMenuCategoryId = selectid;
    },
    selectMenuCate(menuid) {
      this.$refs.itemlistrefs.activeMenu(menuid);
      this.selectMenuCategoryId = menuid;
      this.displayCategory = false;
    },

    minimunOrderValue() {
      this.is_btn_spinner = true;
      if (!this.cart.length) {
        alert(this.$t("Please add Item in to cart"));
        this.is_btn_spinner = false;
        return false;
      }
      var restaurantId = this.cart[0].restaurant_id;
      this.getRestaurantDetails({
        vendor_id: this.$auth.getVendorId(),
        restaurant_id: restaurantId,
        is_langauge: this.$store.state.lang.locale,
      }).then((data) => {
        if (data.code == 200) {
          if (this.$auth.user) {
            if (
              parseFloat(this.getTotalAmount().toFixed(2)) >=
              parseFloat(data.Result.minimum_order_value)
            ) {
              this.is_btn_spinner = false;
              this.$router.push({ name: "review-cart" });
            } else {
              let currency = "";
              if (
                document.getElementById("currency") &&
                document.getElementById("currency").childNodes[0]
              ) {
                currency =
                  document.getElementById("currency").childNodes[0].textContent;
              }
              this.AlertData = {
                displayMessage:
                  this.$t("Minimum items total must be ") +
                  currency +
                  data.Result.minimum_order_value,
                isSetClass: "cart-modal-cls",
              };
              this.isAlert = true;
              this.is_btn_spinner = false;
              window.$(this.$refs.AlertModal).modal();
            }
          } else {
            this.is_btn_spinner = false;
            this.$router.push({ name: "sign-in" });
          }
        }
      });
    },

    onClickOutside() {
      this.displayCategory = false;
    },

    onModalCloseFun(value) {
      this.isAlert = false;
    },
  },
};
</script>
<style>
.skel_view {
  border-radius: 30px !important;
  padding: 5px 10px !important;
  margin-top: 15px;
  background: rgba(0, 0, 0, 0.12);
  width: 25% !important;
  height: 31px !important;
}

ul.day-start,
ul.time-start {
  display: flex;
  flex-wrap: nowrap;
  list-style: none;
  overflow-x: hidden;
  box-shadow: 0px 4px #f1eeee;
  border: 1px solid;
  text-align: center;
}

ul.time-start {
  border: unset;
  overflow-x: scroll;
}

li.day-nme {
  width: 100%;
  text-align: center;
  padding-top: 10px;
}

.select-mnth {
  background-color: #f90909;
  color: #fff;
  text-align: center;
  padding: 10px;
}

li.select-mnth p {
  margin-bottom: auto;
}

li.day-tme {
  padding: 11px;
  font-size: 12px;
  display: inline-table;
  white-space: nowrap;
}

.day-tme p {
  background-color: #ffffff;
  color: #000000;
  padding: 2px;
  border-radius: 5px;
  margin-bottom: 0;
}

.guest-number {
  display: flex;
  justify-content: space-between;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  white-space: pre-line;
  position: relative;
  top: -1px;
}

.cust-mbil {
  display: flex;
}

.cust-mbil span {
  margin: 9px;
  color: red;
}

button.btn.btn-primary.resvation-btn {
  width: 100%;
  background-color: green;
}

li.day-nme.active span {
  color: white;
  background-color: red;
  border-radius: 50%;
  padding: 5px;
}

li.day-nme.active h5 {
  color: black;
}

li.day-nme h5 {
  color: #7f7878;
}

li.day-tme.active p {
  color: white;
  background-color: red;
}

.nottimeslot {
  text-align: center;
}

.nottimeslot p {
  font-size: 15px;
  font-weight: bold;
  margin-top: 7px;
}

.nottimeslot span {
  font-size: 12px;
  display: block;
}

button.btn.resvation-btn.mt-4.btn-default.btn-secondary {
  width: 100%;
  background-color: green;
  border-radius: 40px;
}

.catelist nav ul {
  padding: 0;
  margin: 0;
  list-style: none;
  position: relative;
}

.catelist nav ul li {
  display: inline-block;
}

button.btn.resvation-btn.mt-4.btn-default.btn-secondary.noButtom {
  background-color: gray;
}
.cuisineList{
    /* padding-bottom: 5px !important; */
    margin-bottom: 5px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    white-space: initial;
}
</style>
